import { Breakpoints, styled } from '@vw-marketing/us-components';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${(props) => props.theme.size.static450};

  @media (min-width: ${Breakpoints.b560}px) {
    gap: ${(props) => props.theme.size.static500};
  }

  @media (min-width: ${Breakpoints.b1600}px) {
    gap: ${(props) => props.theme.size.static520};
  }
`;

export const StyledFormDescription = styled.div`
  display: flex;
  gap: ${(props) => props.theme.size.static200};
  align-self: stretch;
  margin-bottom: ${(props) => props.theme.size.static350};

  > div {
    margin: 0;
    font-weight: 300;
  }

  @media (min-width: ${Breakpoints.b560}px) {
    margin-bottom: ${(props) => props.theme.size.static400};
  }
`;
